import { Chains, ExpiryDates, OptionChain, OptionChainResponse, OrganizeOptionDataReturn } from './entities';
import { DateTime } from 'luxon';

const formatDate = (dateString: string) => {
  const pd = DateTime.fromFormat(dateString, 'yyyyMMdd');
  return pd.toFormat('MMMM dd, yyyy');
};

export const organizeOptionData = (data: OptionChainResponse): OrganizeOptionDataReturn => {
  const dataByExpiry: { [key: string]: Chains[] } = {};

  if (Array.isArray(data.optionChains)) {
    data.optionChains?.map((chain: OptionChain) => {
      return chain.chains?.map((expiry: Chains) => {
        if (!dataByExpiry[expiry.mmy]) {
          dataByExpiry[expiry.mmy] = [];
        }

        dataByExpiry[expiry.mmy].push(expiry);
      });
    });
  }

  const expiries: ExpiryDates[] = Object.keys(dataByExpiry).map(expiry => {
    return {
      label: formatDate(expiry),
      value: expiry,
    } as ExpiryDates;
  });

  return {
    dataByExpiry: dataByExpiry,
    expiries: expiries,
  };
};
